import React, {Component} from 'react';
import Inputs from '../../../shared/FormComponents/Inputs';
import _ from 'lodash';
import './HomePageBody.css';
import {
  Link,
} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';


class HomePageBody extends Component {

  constructor(props) {
    super(props);
    this.defaultParams = {};
    this.state = {
      questionsData: {
        email: '',
        phone: '',
        message: '',
      },
      inputStates: {
        email: false,
        phone: false,
        message: false,
      }
    };
  }

  onDataChange = (key, value, valid) => {
    const state = _.extend({}, this.state);
    state.inputStates[key] = valid;
    if(key === 'message'){
      state.questionsData[key] = value.target.value;
    }else{
      state.questionsData[key] = value;
    }
    this.setState(state, () => this.validateForm());
  };

  validateForm = () => {
    let validationStates = _.extend({}, this.state.inputStates);
    let key = Object.values(validationStates).indexOf(false) !== -1;
    let state = !key;
    this.setState({ formValid: state });
  }

  sendQuestions = () => {
    this.props.sendMessage(this.state.questionsData)
    // console.log(this.state.questionsData, this.state.inputStates)
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.messageSuccess && nextProps.messageSuccess.statusCode){
      toast.success('Your message was sent successfully.');
      setTimeout(() => {
        window.location.reload()
      }, 5000);
    }
  }

  render() {
    return (
      <div className="home_body">
        <div className='leftSide'>
          <div className='pyramid'></div>
          <h5>The Insight Pyramid</h5>
          <p>Impact’s Action Learning Workshops turn data, information and knowledge into Customer Insight</p>
        </div>
        <div className='rightSide'>
          <h1>We Solve Marketing Strategy Problems</h1>
          <p>Want to build a world-class strategic marketing plan?  Welcome to Impact’s Planning Tools, where you can develop a strategy to…</p>
          <ul>
            <li>Win (or keep winning) in your marketplace</li>
            <li>Successfully launch a new product</li>
            <li>Gain support and funding for your idea</li>
            <li>…or all the above!</li>
          </ul>
          <h2>Launch The Planning Tools!</h2>
          <p> <span className='fas fa-hand-point-right'></span> Already registered? Please  <Link to='/login'> log in</Link></p>
          <p> <span className='fas fa-hand-point-right'></span> <bold>This is your first visit? Click here to </bold> <Link to='/registration'>get started </Link> </p>
          <p>Not sure?   The Planning Tools are accessible by invitation only.  You can gain admission by being invited by your employer, or directly from Impact Planning Group.  If you are not sure if you have access to these tools, please contact us:</p>
          <ul>
            <li>Email us @ tspitale@impactplan.com</li>
            <li>Call us @ (01) 412-671-7031 </li>
          </ul>
          <p>For more information on Impact Planning Group, please visit our websites:</p>
          <p>
            <span className='fas fa-hand-point-right'></span>
            <a href='https://www.impactplan.com' target="_blank">www.impactplan.com </a>
          </p>
          <p>
            <span className='fas fa-hand-point-right'></span>
            <a href='https://www.theaccidentalmarketer.com' target="_blank">www.theaccidentalmarketer.com</a>
          </p>
          <h2>Send a message via this site</h2>
          <form>
            <div className="form-group">
              <Inputs
                type="login"
                className="form-control"
                value={this.state.questionsData.email}
                required={ true }
                placeholder='Email'
                onChange={ (value, valid) => this.onDataChange('email', value, valid)}
              />
            </div>
            <div className="form-group">
              <Inputs
                type="phone"
                className="form-control"
                value={this.state.questionsData.phone}
                required={ true }
                placeholder='Phone'
                onChange={ (value, valid) => this.onDataChange('phone', value, valid)}
              />
            </div>
            <div className="form-group">
              <textarea
                onChange={ (e, valid) => this.onDataChange('message', e, valid)}
                // value={this.state.questionsData.message}
                placeholder='Message'
                className="form-control"
              >
              </textarea>
            </div>
            <button type="button" className="btn btn-success" disabled={!this.state.formValid}  onClick={() => {this.sendQuestions()}}>SEND</button>
          </form>
        </div>
      </div>
    )
  }
}

export default (HomePageBody);



// WEBPACK FOOTER //
// ./src/components/Home/HomePageBody/HomePageBody.jsx